import type { NoodlNode } from '@shared/node-v1.0.0'
import { sendSignal } from '@shared/port-send-v1.0.0'
import systemLoaderAnimation from '@shared/system-loader-animation-v0.3.0'
import type { Props } from '../definition'
import setConfig from './setConfig'

export default async (p: Props, noodlNode: NoodlNode) => {
	const { kuzzleDefaultDbName, useCustomKuzzle, kuzzleUrl, kuzzlePort } = p
	const { project, environment = 'd3' } = Noodl.getProjectSettings()

	R.env.dbName = kuzzleDefaultDbName

	if (!project || !environment) {
		log.error('Kuzzle init: empty required props', { project, environment })
		return
	}

	const startTime = log.start()

	const kuzzleModule = await import('kuzzle-sdk')
	const host = useCustomKuzzle ? kuzzleUrl || 'localhost' : `kuzzle.${project}.${environment}.rolder.app`
	const port = useCustomKuzzle ? kuzzlePort || 7512 : 443
	noodlNode._internal.host = host
	noodlNode._internal.port = port

	const kuzzle = new kuzzleModule.Kuzzle(new kuzzleModule.WebSocket(host, { port }))

	if (p.useNetwork) {
		if (R.db?.states.network.connected) {
			await kuzzle.connect()
			systemLoaderAnimation.progress(60)
			await setConfig(kuzzle, true)

			log.end('Kuzzle online init', startTime)
		} else {
			await setConfig(kuzzle, false)
			log.end('Kuzzle offline init', startTime)
		}
	} else {
		await kuzzle.connect()
		systemLoaderAnimation.progress(60)
		await setConfig(kuzzle, true)

		log.end('Kuzzle online init (no network check)', startTime)
	}

	R.libs.Kuzzle = kuzzle
	sendSignal(noodlNode, 'initialized')
}
